module.exports = __webpack_public_path__ + "static/media/schoolpic01@3x.8fdbe5a1.png";